// Terms of Service and Privacy Policy text, shared by the public pages, the
// sign-up checkbox and the Word copies. Edit legal.json, then bump TERMS_VERSION
// in the backend (main.py) to match when the wording changes materially.
import legal from './legal.json';

export default legal;
